import React from 'react';
import { withStyles, Typography, Button } from '@material-ui/core';
import ContentHeader from '../components/ContentHeader';
import './Help.css';
import globalStyles from '../styles';

const styles = theme => ({
    root: {
        textAlign: 'left',
        border: '0',
        maxWidth: '600px',
        margin: '40px auto',
        position: 'relative',
        background: '#fff',
        boxShadow: '0px 2px 5px 0px rgba(0,0,0,0.21)',
        [theme.breakpoints.down('sm')]: {
            maxWidth: '100%',
            margin: '20px 15px'
        }
    },
    heading: {
        marginBottom: '10px',
        fontSize: 22
    },
    subheading: {
        marginTop: '20px'
    },
    paragraph: {
        fontSize: '16px',
        marginBottom: '10px',
        fontWeight: '100'
    },
    inner: {
        padding: '20px 10px'
    },
    link: globalStyles.link
});

const Help = ({ classes }) => {
    return (
        <div className={classes.root}>
            <ContentHeader text="Help" id="help-heading" />
            <div className={classes.inner}>
                <Typography className={classes.paragraph} variant="body2">
                    To ensure your issue is dealt with as quick as possible, we
                    need to determine the type of query you have.
                </Typography>
                <div style={{ paddingTop: 15, borderTop: '2px solid #eee' }}>
                    <Typography className={classes.heading} variant="h4">
                        I have a query about the bus service
                    </Typography>
                    <Typography className={classes.paragraph} variant="body2">
                        <strong>
                            Any query regarding the below items needs to go to
                            Dartline Coaches:{' '}
                            <a
                                className={classes.link}
                                href="mailto:info@dartline-coaches.co.uk"
                            >
                                info@dartline-coaches.co.uk
                            </a>{' '}
                            or call 01392 872900
                        </strong>
                    </Typography>
                    <div className="two-col">
                        <ul>
                            <li>Timetables</li>
                            <li>Route/bus stops</li>
                            <li>Ticket prices</li>
                            <li>Ticket options</li>
                            <li>Ticket availability</li>
                        </ul>
                        <ul>
                            <li>Payments</li>
                            <li>Renewals</li>
                            <li>Discounts/bursaries</li>
                            <li>Refunds/cancellations</li>
                            <li>Lost property</li>
                        </ul>
                    </div>
                </div>
                <div style={{ paddingTop: 15, borderTop: '2px solid #eee' }}>
                    <Typography className={classes.heading} variant="h4">
                        I have a technical query about purchasing or using my
                        ticket
                    </Typography>
                    <Typography className={classes.paragraph} variant="body2">
                        The ShuttleID support team can only assist with
                        technical queries regarding the purchase process and the
                        use of the ticket itself.
                    </Typography>
                    <Typography className={classes.paragraph} variant="body2">
                        For guidance on how to complete your purchase or how to
                        use your ticket, visit the ShuttleID{' '}
                        <a
                            className={classes.link}
                            href="https://help.shuttleid.uk"
                        >
                            Help Portal
                        </a>
                        . Most queries are answered here and will allow you to
                        resolve your issue immediately, without further delay.
                    </Typography>
                    <Typography className={classes.paragraph} variant="body2">
                        The ShuttleID{' '}
                        <a
                            className={classes.link}
                            href="https://help.shuttleid.uk"
                        >
                            Help Portal
                        </a>{' '}
                        is available 24/7, enabling you to answer your query
                        straight away, when it&apos;s convenient for you.
                    </Typography>
                    <Typography className={classes.paragraph} variant="body2">
                        <Button
                            className={`${classes.button} ${classes.buyAgainButton}`}
                            variant="outlined"
                            color="primary"
                            component="a"
                            target="_blank"
                            href="https://help.shuttleid.uk"
                        >
                            Visit Help Portal
                        </Button>
                    </Typography>
                    <Typography className={classes.paragraph} variant="body2">
                        If you are purchasing a ticket via ShuttleID for the
                        first time, please contact us (Dartline Coaches) for a
                        link to our ticket listing on the ShuttleID Passenger
                        Portal.
                    </Typography>
                    <Typography className={classes.paragraph} variant="body2">
                        For any other technical issues that are not already
                        covered by the help portal, please email{' '}
                        <a
                            className={classes.link}
                            href="mailto:support@shuttleid.uk"
                        >
                            support@shuttleid.uk
                        </a>
                        . The ShuttleID support team will endeavour to respond
                        to your request within 24 hours.
                    </Typography>
                </div>
            </div>
        </div>
    );
};

export default withStyles(styles)(Help);
